var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section section-shop columns is-multiline mt-0"},_vm._l((_vm.shops),function(shop){return _c('ShopCard',{key:shop.id,attrs:{"shop":shop}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }